<template>

    <Toast/>

    <MenuLogin/>
    <HeadingLogin/>

    <div class="px-6 surface-overlay relative">

        <div class="border-2 surface-border border-round surface-section flex-auto">

            <div class="flex flex-wrap">
                <div class="w-full lg:w-6 p-4 lg:p-7" style="background-color: rgba(255,255,255,.7)">
                    <div class="text-xl text-900 font-500 mb-3">Welcome to the Kitrin IsoEvolve Software</div>
                    <p class="text-600 line-height-3 mt-0 mb-6">The only practice management software in South
                        Africa and the UK that has a CPD Module, a Practice Management Module and Managed
                        Service Module.</p>
                    <ul class="list-none p-0 m-0">
                        <li class="flex align-items-start mb-4">
                            <div>
                                      <span class="flex align-items-center justify-content-center bg-purple-400"
                                            style="width:38px;height:38px;border-radius:10px">
                                          <i class="text-xl text-white pi pi-inbox"></i>
                                      </span>
                            </div>
                            <div class="ml-3">
                                <span class="font-medium text-900">CPD Module</span>
                                <!--                                <p class="mt-2 mb-0 text-600 line-height-3">An innovative way for each-->
                                <!--                                    healthcare practitioner to get their CPD points for the year,-->
                                <!--                                    which includes 24 clinical points and 6 ethical points.</p>-->
                            </div>
                        </li>
                        <li class="flex align-items-start mb-4">
                            <div>
                                      <span class="flex align-items-center justify-content-center bg-purple-400"
                                            style="width:38px;height:38px;border-radius:10px">
                                          <i class="text-xl text-white pi pi-shield"></i>
                                      </span>
                            </div>
                            <div class="ml-3">
                                <span class="font-medium text-900">Practice Management Module</span>
                                <!--                                <p class="mt-2 mb-0 text-600 line-height-3">Everything you would expect from a-->
                                <!--                                    practice management software including making appointments,-->
                                <!--                                    generating invoices, allowing your patients to complete electronic forms,-->
                                <!--                                    etc.</p>-->
                            </div>
                        </li>
                        <li class="flex align-items-start">
                            <div>
                                      <span class="flex align-items-center justify-content-center bg-purple-400"
                                            style="width:38px;height:38px;border-radius:10px">
                                          <i class="text-xl text-white pi pi-globe"></i>
                                      </span>
                            </div>
                            <div class="ml-3">
                                <span class="font-medium text-900">Managed Service Module</span>
                                <!--                                <p class="mt-2 mb-0 text-600 line-height-3">A revolutionary way to upgrade your-->
                                <!--                                    current practice management software to allow you to-->
                                <!--                                    have a dedicated phone number, get your phone calls answered while you're-->
                                <!--                                    busy with clients, get your website done, get your invoicing done,-->
                                <!--                                    and get all medical aids automatically followed up on. Even if you have a-->
                                <!--                                    current billing company, it's a great way to see the progress-->
                                <!--                                    of everything happening in your private practice.</p>-->
                            </div>
                        </li>
                    </ul>
                </div>

                <div v-show="activeTab === 1" class="w-full lg:w-6 p-4 lg:p-7 surface-card">
                    <div class="text-900 text-2xl font-medium mb-6">Login</div>

                    <div class="field">
                        <label for="username" class="block text-900 font-medium mb-2">Username</label>
                        <InputText id="username" type="text" v-model="userData.username" placeholder="Username"
                                   class="w-full mb-4"/>
                    </div>

                    <div class="field">
                        <label for="password" class="block text-900 font-medium mb-2">Password</label>

                        <InputText id="password"
                                   :type="showPassword ? 'text' : 'password'"
                                   v-model="userData.password"
                                   placeholder="Password"
                                   class="w-full pr-10 mb-4"/>
                    </div>

                    <!-- Show Password Toggle -->
                    <div class="flex align-items-center justify-content-between mb-6">
                        <div class="flex align-items-center">
                            <Checkbox id="showPasswordToggle" :binary="true" v-model="showPassword" class="mr-2"></Checkbox>
                            <label for="showPasswordToggle">Show Password</label>
                        </div>
                        <div class="flex align-items-center">
                            <Checkbox id="rememberme" :binary="true" v-model="rememberme"
                                      class="mr-2"></Checkbox>
                            <label for="rememberme">Remember me</label>
                        </div>
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleForgotPassword">
                            Forgot password?
                        </a>
                    </div>

<!--                    <div class="field">-->
<!--                        <label for="password" class="block text-900 font-medium mb-2">Password</label>-->
<!--                        <InputText id="password" type="password" v-model="userData.password" placeholder="Password"-->
<!--                                   class="w-full mb-4"/>-->
<!--                    </div>-->

<!--                    <div class="flex align-items-center justify-content-between mb-6">-->
<!--                        <div class="flex align-items-center">-->
<!--                            <Checkbox id="rememberme" :binary="true" v-model="rememberme"-->
<!--                                      class="mr-2"></Checkbox>-->
<!--                            <label for="rememberme">Remember me</label>-->
<!--                        </div>-->
<!--                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"-->
<!--                           @click="handleForgotPassword">Forgot-->
<!--                            password?</a>-->
<!--                    </div>-->

                    <Button label="Login" icon="pi pi-user" class="w-full" :loading="submitted" @click="handleLogin"></Button>

                    <div class="mt-6 text-center text-600">
                        Don't have an account?
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleRegister">Sign Up</a>
                    </div>
                </div>

                <div v-show="activeTab === 2" class="w-full lg:w-6 p-4 lg:p-7 surface-card">
                    <div class="text-900 text-2xl font-medium mb-6">Login</div>

                    <div class="field">
                        <label for="activationCode" class="block text-900 font-medium mb-2">Activation Code</label>
                        <InputText id="activationCode" type="text" v-model="userData.activationCode"
                                   placeholder="Activation Code"
                                   class="w-full mb-4"/>
                    </div>

                    <div class="flex align-items-center justify-content-between mb-6">
                        <div class="flex align-items-center">
                            <Checkbox id="rememberme" :binary="true" v-model="rememberme"
                                      class="mr-2"></Checkbox>
                            <label for="rememberme">Remember me</label>
                        </div>
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleForgotPassword">Forgot
                            password?</a>
                    </div>

                    <Button label="Login" icon="pi pi-user" class="w-full" :loading="submitted" @click="handleLogin"></Button>

                    <div class="mt-6 text-center text-600">
                        Don't have an account?
                        <a class="font-medium no-underline ml-2 text-teal-500 text-right cursor-pointer"
                           @click="handleRegister">Sign Up</a>
                    </div>
                </div>

            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import HeadingLogin from "@/components/heading/authentication/HeadingLogin.vue";
import MenuLogin from "@/components/menu/authentication/MenuLogin.vue";
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import AuthenticationService from "@/service/AuthenticationService";
import CompanyService from "@/service/CompanyService";
import DashboardService from "@/service/DashboardService";
import AuditTrailService from "@/service/AuditTrailService";
import ProductService from "@/service/ProductService";
import PractitionerService from "@/service/PractitionerService";
import LocationService from "@/service/LocationService";
import BillingPlanService from "@/service/BillingPlanService";
import SupplierService from "@/service/SupplierService";
import ClientService from "@/service/ClientService";

export default {
    components: {
        MenuLogin,
        HeadingLogin,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[Login][mounted] System is active.");
            console.log("[Login][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[Login][mounted] System is NOT active.");
            console.log("[Login][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[Login][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }
    },
    data() {
        return {
            activeTab: 1,
            userData: {},
            profile: {},
            submitted: false,
            rememberme: false,
            showPassword: false
        }
    },
    methods: {
        handleActivationCode() {
            console.log("[Login][handleActivationCode] Start of function. Redirecting to functionality.");

            this.submitted = true;
            this.activeTab = 2;

            AuthenticationService.twoFactorAuthentication(this.userData.username)
                .then(data => {
                    console.log("[Login][handleLogin] Response data = ", data);

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Activation Code Successful Sent via Email',
                        life: 3000
                    });

                })
                .catch(e => {
                    console.log("[Login][mounted] Error = ", e);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Activation Code NOT Sent via Email',
                        life: 3000
                    });
                    this.activeTab = 1;
                    this.userData.username = '';
                    this.userData.password = '';
                    this.userData.activationCode = '';
                });

            this.submitted = false;

        },
        handleResult(index, result) {
            console.log("[Login][handleResult] index = ", index);
            console.log("[Login][handleResult] result = ", result);

            switch (index) {
                case 0:
                    this.userStore.setCompanyConfiguration(result.data);
                    break;
                case 1:
                    this.userStore.setFinancialSummary(result.data);
                    break;
                case 2:
                    this.userStore.setAuditTrails(result.data);
                    console.log("[Login][handleResult] this.userStore.auditTrails = ", this.userStore.auditTrails);
                    break;
                case 3:
                    this.userStore.setUsers(result.data);
                    break;
                case 4:
                    this.userStore.setProducts(result.data);
                    break;
                case 5:
                    this.userStore.setPractitioners(result.data);
                    break;
                case 6:
                    this.userStore.setLocations(result.data);
                    break;
                case 7:
                    this.userStore.setBillingPlans(result.data);
                    break;
                case 8:
                    this.userStore.setSuppliers(result.data);
                    break;
                case 9:
                    this.userStore.setClients(result.data);
                    break;
                default:
                    console.warn(`Unhandled result at index ${index}:`, result);
            }
        },
        loadDataInBackground() {
            console.log("[Login][loadDataInBackground] Start of function.");

            const promises = [
                CompanyService.getCompanyConfiguration(this.userStore.user.companyId),
                DashboardService.getFinancialSummaryOverThreeMonthsForCompany(this.userStore.user.companyId),
                AuditTrailService.getCompanyAuditTrails(this.userStore.user.companyId),
                UserService.getCompanyUsers(this.userStore.user.companyId),
                ProductService.getCompanyProducts(this.userStore.user.companyId),
                PractitionerService.getCompanyPractitioners(this.userStore.user.companyId),
                LocationService.getCompanyLocations(this.userStore.user.companyId),
                BillingPlanService.getActiveBillingPlans(this.userStore.user.companyId),
                SupplierService.getCompanySuppliers(this.userStore.user.companyId),
                ClientService.getBasicCompanyClients(this.userStore.user.companyId)
            ];

            // Run the promises but do not await them.
            promises.forEach((promise, index) => {
                promise.then(result => {
                    // Handle the result here, e.g., assign to a data property
                    this.handleResult(index, result);
                }).catch(error => {
                    // Handle the error here
                    console.error("Error in promise", index, error);
                });
            });
        },
        async handleLogin() {
            console.log("[Login][handleLogin] Start of function. Redirecting to functionality.");

            this.submitted = true;

            try {
                var createData = {
                    username: this.userData.username,
                    password: this.userData.password,
                    activationCode: this.userData.activationCode,
                };

                console.log("[Login][handleLogin] createData = ", createData);

                const responseData = await AuthenticationService.authenticateUser(createData);
                console.log('[Login][handleLogin] Response = ', responseData);

                this.userStore.setUserToken(responseData.data);
                console.log("[Login][mounted] this.userStore.accessToken = ", this.userStore.accessToken);
                console.log("[Login][mounted] this.userStore.userId = ", this.userStore.userId);
                console.log("[Login][mounted] this.userStore.companyId = ", this.userStore.companyId);
                console.log("[Login][mounted] this.userStore.username = ", this.userStore.username);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Login successful',
                    life: 3000
                });

                const userData = await UserService.getUser(responseData.data.id);
                console.log("[Login][mounted] userData = ", userData);

                const promises = [
                    UserService.getUser(responseData.data.id),
                    UserService.getUserConfig(responseData.data.id)
                ];

                const [userResult, userConfigResult] =
                    await Promise.allSettled(promises);

                if (userResult.status === "fulfilled") {
                    this.userStore.setUser(userResult.value.data);
                    console.log("[Login][mounted] this.userStore.user = ", this.userStore.user);
                } else {
                    console.log("[Login][mounted] Error = ", userResult.reason);
                }

                if (userConfigResult.status === "fulfilled") {
                    this.userStore.setUserConfiguration(userConfigResult.value.data);
                } else {
                    console.log("[Login][mounted] Error = ", userConfigResult.reason);
                }

                this.loadDataInBackground();

                if (this.userStore.user) {

                    if (this.userStore.user.roles.includes("ROLE_ISOEVOLVE", 0)) {
                        console.log("[Login][handleLogin] Processing role for ROLE_ISOEVOLVE");
                        this.$router.push("msOverviewHome");
                    } else if (this.userStore.user.roles.includes("ROLE_ISOPRACTICE", 0)) {
                        console.log("[Login][handleLogin] Processing role for ROLE_ISOPRACTICE");
                        this.$router.push("pmOverviewHome");
                    } else if (this.userStore.user.roles.includes("ROLE_ISORISE", 0)) {
                        console.log("[Login][handleLogin] Processing role for ROLE_ISORISE");
                        this.$router.push("faOverviewHome");
                    } else if (this.userStore.user.roles.includes("ROLE_ISOWEB", 0)) {
                        console.log("[Login][handleLogin] Processing role for ROLE_ISOWEB");

                        if (this.userStore.user.rights === 'R') {
                            this.$router.push("siAffiliate");
                        } else {
                            this.$router.push("siOverview");
                        }

                    } else {
                        console.log("[Login][handleLogin] Processing default role");
                        this.$router.push("userOverview");
                    }
                }

            } catch (error) {
                console.error('[Login][deletePhoneCall] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to login. Please try again.',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.userData = {};
            this.userData.username = '';
            this.userData.password = '';
            this.userData.activationCode = '';
            this.submitted = false;

        },
        handleForgotPassword() {
            console.log("[Login][handleForgotPassword] Start of function. Redirecting to functionality.");
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Password Reset Initiated',
                life: 3000
            });
            this.$router.push("forgotPassword");
        },
        handleRegister() {
            console.log("[Login][handleRegister] Start of function. Redirecting to functionality.");
            this.$toast.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Registration Initiated',
                life: 3000
            });
            this.$router.push("register");
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
